var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1668 20.1693L1.8335 1.83594",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 9.16406C16.1606 9.86687 16.5002 10.7273 16.5002 11.6569C16.5002 12.0639 16.4351 12.4576 16.3134 12.8307",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 7.33594C19.4801 8.46299 20.1668 9.8982 20.1668 11.4609C20.1668 12.7593 19.6928 13.9696 18.8749 14.9883",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 12.8307C12.8335 15.7138 12.8335 17.9011 11.9847 18.2599C11.1359 18.6187 10.1369 17.5993 8.13897 15.5607C7.10424 14.5049 6.514 14.2711 5.04183 14.2711C4.0224 14.2711 2.77536 14.4062 2.14247 13.4397C1.8335 12.9679 1.8335 12.3111 1.8335 10.9974C1.8335 9.68372 1.8335 9.02691 2.14247 8.55508C2.77536 7.5886 4.0224 7.72369 5.04183 7.72369C6.05681 7.72369 6.74399 7.73286 7.29683 7.29406M12.8335 8.70573C12.8335 5.82263 12.8573 4.09367 12.0085 3.73492C11.3019 3.43624 10.5714 4.09274 9.16683 5.4974",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.c69bf141aadcc0619c0e2155f28ca73a.svg";
export { ForwardRef as ReactComponent };